import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M1260 12789 c-41 -6 -76 -11 -77 -12 -1 -2 9 -164 22 -362 14 -198
          25 -376 25 -395 l0 -36 -69 -17 c-243 -63 -483 -257 -594 -482 -50 -100 -68
          -166 -74 -275 -9 -166 35 -307 134 -425 84 -101 126 -125 628 -347 219 -97
          285 -113 459 -105 316 14 639 164 897 417 123 121 205 233 274 374 66 134 102
          254 114 387 34 361 -117 691 -400 876 -73 47 -590 289 -729 341 -120 44 -226
          63 -385 67 -82 2 -184 -1 -225 -6z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
